import { executeWithTimeout, getErrorAsString, getResponseDiagnostics, HttpResponseError, OneNoteApi, UrlUtils } from '@notes/webintegrations-common'
import { Log } from '../logger/Log'

export class ApiUtils {
  public static async makeFetchRequest(
    requestName: string,
    requestUrl: string,
    method: string,
    // tslint:disable-next-line:no-any
    headers: any,
    body?: string,
    queryParams?: {[key: string]: string | undefined},
    timeout: number = 15000): Promise<Response> {
    if (queryParams) {
      for (const key of Object.keys(queryParams)) {
        const queryParam = queryParams[key]
        if (queryParam) {
          requestUrl = UrlUtils.addQueryParam(requestUrl, key, queryParam)
        }
      }
    }

    const fetchRequest = fetch(requestUrl, {
      method: method,
      headers: headers,
      body: body,
    })

    let response
    try {
      response = await executeWithTimeout(timeout, fetchRequest, requestName)
    } catch (error) {
      Log.logger.error(`Error when making fetch request. ${getErrorAsString(error)}`)
      throw error
    }

    if (!response.ok) {
      const responseDiagnostics = getResponseDiagnostics(response)
      const error = new HttpResponseError(responseDiagnostics, response.status)
      Log.logger.error(`Invalid response from fetch request. ${responseDiagnostics}`)
      throw error
    }

    Log.logger.info(`Successfully made fetch request. ${requestName}`)
    return response
  }

  // tslint:disable-next-line:no-any
  public static async getResponseJson(response: Response): Promise<any> {
    try {
      return await response.json()
    } catch (error) {
      Log.logger.error(`Ran into an error when parsing response JSON. ${getErrorAsString(error)}`)
      throw error
    }
  }

  public static buildOneNoteApi(accessToken: string): OneNoteApi {
    const headers: { [key: string]: string } = {
      'If-Match': '*', // For the UserInfo API - forces the setting to be updated
    }
    headers['MS-Int-AppId'] = 'NotesTeamsIntegration'

    return new OneNoteApi(
      'Bearer ' + accessToken,
      30000,
      headers,)
  }
}
